"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = exports.PoliciesContainer = exports.Title = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("../../Typography"));
exports.Container = styled_components_1.default.div `
  display: flex;
  align-items: flex-start;
  margin-right: ${props => props.theme.spacing.m3}px;

  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    ${props => (props.copyrightInsideContainer ? 'align-items: center;' : null)}
    margin: 0 0 ${props => props.theme.spacing.s4}px 0;
  }

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    align-items: center;
    flex-direction: column;
  }
`;
exports.Title = (0, styled_components_1.default)(Typography_1.default) `
  margin-right: ${props => props.theme.spacing.m1}px;
  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    margin-bottom: ${props => props.theme.spacing.s2}px;
  }
`;
exports.PoliciesContainer = styled_components_1.default.div `
  display: flex;
  > span {
    margin-right: ${props => props.theme.spacing.s2}px;
    margin-left: ${props => props.theme.spacing.s2}px;
  }
`;
exports.Link = styled_components_1.default.a `
  color: inherit;
  &:hover {
    color: ${props => props.theme.palette.DARK_GRAY_100};
  }
`;
exports.default = {
    Container: exports.Container,
    Title: exports.Title,
    PoliciesContainer: exports.PoliciesContainer,
    Link: exports.Link
};
